export default __webpack_public_path__ + "static/media/valley_map.d07212bb.png";